<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }"> {{ text }} </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import IDFilter from "../../filterImplementations/IDFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<IDFilter>,
    required: true,
  },
});
const { t } = useTranslation();
const sortedIDs = computed(() => [...props.filter.ids].sort((left, right) => right - left));
const text = computed(() => {
  const typeText = props.filter.type ? t(`global.EABTypes.${props.filter.type}`) : t(`global.all`);
  return `${typeText}${sortedIDs.value.length > 0 ? " | " : ""}${sortedIDs.value.join(", ")}`;
});
</script>

<style lang="scss" scoped></style>
